import cx from "classnames"
import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { formatTextWithCapitalize } from "src/shared/hooks/formatTextOpcions"
import { capitalize } from "src/shared/helpers/capitalize"
import { formatMetodoPago, formatSplitValue } from "src/shared/helpers/formatMetodoPago"
import { OrdenesDetailProps } from "./OrdenesDetail.type"
import "./OrdenesDetail.css"

const emptyValue = "-"

// cada estatus se pinta con el color que le corresponde: pagada en verde, pendiente en
// amarillo y cancelada en rojo
const STATUS_COLOR: Record<string, string> = {
    pagada: "success",
    entregada: "success",
    pendiente: "warning",
    no_pagada: "warning",
    pago_parcial: "warning",
    por_entregar: "warning",
    en_preparacion: "warning",
    en_entrega: "warning",
    en_servicio: "warning",
    cancelada: "danger",
    cancelada_edicion: "danger",
    devolucion: "danger",
}

// el origen llega como "Suite villa / 301": se junta en una sola línea, sin diagonales
const formatOrigen = (origen?: string) => {
    const parts = (origen || "")
        .split("/")
        .map((part) => part.trim())
        .filter(Boolean)

    if (!parts.length) {
        return ""
    }

    return parts.map((part, index) => (index === 0 ? capitalize(part) : part)).join(" ")
}

const OrdenesDetail = ({ isOpen, onClose, data }: OrdenesDetailProps): JSX.Element => {
    // la fecha del reporte ya llega formateada desde el endpoint, se muestra igual que en la tabla
    const origen = formatOrigen(data?.origen)
    const estatus = data?.estatus_pago || data?.estatus_orden || ""
    const statusColor = STATUS_COLOR[estatus.toLowerCase()]

    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton onClose={onClose} testId="ordenes-detail">
            <div className="ordenes-detail__head">
                <p className="ordenes-detail__title">{`Orden - ${data?.orden || emptyValue}`}</p>
                <p className="ordenes-detail__subtitle">
                    {origen || emptyValue}
                    {!!estatus && (
                        <>
                            {" - "}
                            <span className={cx({ [`ordenes-detail__status--${statusColor}`]: !!statusColor })}>
                                {formatTextWithCapitalize(estatus)}
                            </span>
                        </>
                    )}
                </p>
            </div>
            <div className="ordenes-detail__body">
                <div className="ordenes-detail__description">
                    <DescriptionDetail icon={"FileListFill"} label={"Turno"} value={data?.turno || emptyValue} />
                    <DescriptionDetail
                        icon={"calendarFill"}
                        label={"Fecha y hora"}
                        value={data?.fecha_venta || emptyValue}
                    />
                    <DescriptionDetail
                        className={"ordenes-detail__value--full"}
                        icon={"userFilled"}
                        label={"Responsable"}
                        value={data?.atendio || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"dollarCircle"}
                        label={"Total"}
                        value={formatCurrencyToFixed(Number(data?.total) || 0)}
                    />
                    <DescriptionDetail
                        className={"ordenes-detail__value--full"}
                        icon={"creditCard"}
                        label={"Método de pago"}
                        value={formatSplitValue(data?.metodos_pago, formatMetodoPago)}
                    />
                </div>
            </div>
        </Drawer>
    )
}

export default OrdenesDetail
